import { useState } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import { useToast } from '@/hooks/use-toast';
import { criarRotinaVazia, mensagemDeErro } from '@/services/api/rotinas';
import { DIAS_SEMANA } from './rotinaUtils';

export default function NovaRotinaDialog({ open, onOpenChange, dia }: {
    open: boolean;
    onOpenChange: (o: boolean) => void;
    dia: number;
}) {
    const { toast } = useToast();
    const queryClient = useQueryClient();
    const [nome, setNome] = useState('');
    const criar = useMutation({
        mutationFn: () => criarRotinaVazia(nome.trim(), dia),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['rotinas-agendamento'] });
            setNome('');
            onOpenChange(false);
            toast({ title: 'Rotina criada', description: 'Nasce desligada: ligue quando estiver pronta.' });
        },
        onError: (e) => toast({ variant: 'destructive', title: 'Não foi possível criar', description: mensagemDeErro(e, 'Tente de novo.') }),
    });
    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="max-w-md">
                <DialogHeader>
                    <DialogTitle>Nova Rotina de {DIAS_SEMANA[dia]}</DialogTitle>
                    <DialogDescription>
                        Nasce vazia e <b>desligada</b>: pode ser montada com calma sem disparar nada, mesmo hoje.
                        Use "Novo grupo" ou "Grupo a partir de um broadcast" e ligue quando estiver pronta — só uma
                        Rotina fica no ar por dia, então desligue a atual antes de ligar esta.
                    </DialogDescription>
                </DialogHeader>
                <Input placeholder="Nome (ex: Segunda padrão)" value={nome} onChange={(e) => setNome(e.target.value)} />
                <DialogFooter>
                    <Button variant="outline" onClick={() => onOpenChange(false)} disabled={criar.isPending}>Cancelar</Button>
                    <Button onClick={() => criar.mutate()} disabled={!nome.trim() || criar.isPending}>
                        {criar.isPending && <Loader2 className="mr-1 h-4 w-4 animate-spin" />}
                        Criar
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
